export function getUnitScale(unit, scale) {
  switch (unit) {
    case 'mm':
      return (scale *= 10);
    case 'cm':
      return (scale *= 1);
    case 'm':
      return (scale *= 0.01);
    default:
      return (scale *= 1);
  }
}

export function getBeaconBoundaryByUnit(unit, radius = 2.5, height = 1) {
  switch (unit) {
    case 'mm':
      radius *= 1000;
      height *= 1000;
      break;
    case 'cm':
      radius *= 100;
      height *= 100;
      break;
    case 'm':
      break;
  }

  return { radius, height };
}

export function meterToDrawingUnit(unit, value) {
  switch (unit) {
    case 'mm':
      return value * 1000;
    case 'cm':
      return value * 100;
    case 'm':
    default:
      return value;
  }
}
